import React, {Component} from 'react';
import './Default.css'
import objeler from '../objeler';

class Shape extends Component {
    constructor(props) {
        super(props);
        const {JpgBlob} = this.props;
        const inputRef = React.createRef(null);
        this.imgOnLoad = this.imgOnLoad.bind(this)
        this.imgRef = React.createRef();
    };

    componentDidMount() {
    }

    imgOnLoad() {
        const height = this.imgRef.current.naturalHeight
        const width = this.imgRef.current.naturalWidth
        const ElementProps = objeler['ElementProps'];
        ElementProps.JpgOriginalWidth = width;
        ElementProps.JpgOriginalHeight = height;
        ElementProps.JpgOriginalAspectRatio = width / height;
        const {pictureOnLoad} = this.props;
        pictureOnLoad(ElementProps);
    }

    render() {
        String.prototype.format = function () {
            var a = this;
            var k;
            for (k in arguments) {
                a = a.replace("{" + k + "}", arguments[k])
            }
            return a
        }
        var BorderHelpers = {
            strokeArray: function (style, border) {
                var strokeArray = "0pt";
                switch (style) {
                    case "Dash":
                        strokeArray = "{0}pt,{1}pt".format(border * 3, border);
                        break;
                    case "Dot":
                        strokeArray = "{0}pt".format(border);
                        break;
                    case "DashDot":
                        strokeArray = "{0}pt,{1}pt,{2}pt,{3}pt".format(border * 3, border, border, border);
                        break;
                    case "DashDotDot":
                        strokeArray = "{0}pt,{1}pt,{2}pt,{3}pt,{4}pt,{5}pt".format(border * 3, border, border, border, border, border);
                        break;
                    default:
                }
                return strokeArray;
            },
            GetFill: function (fill, color) {
                if (fill)
                    return color;
                return "none";
            }
        };
        const {file, content, type, BorderColor, BorderStyle, BorderWidth, FillColor, Fill, Direction} = this.props;
        const imgstyle = {
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        };
        var vy1;
        var vy2;
        var vx1;
        var vx2;
        switch (Direction) {
            case "Free":
                vx1 = "0";
                vy1 = "0";
                vx2 = "100%";
                vy2 = "100%";
                break;
            case "Flip":
                vx1 = "100%";
                vy1 = "0";
                vx2 = "0";
                vy2 = "100%";
                break;
            case "Horizontal":
                vx1 = "0%";
                vy1 = "50%";
                vx2 = "100%";
                vy2 = "50%";
                break;
            case "Vertical":
                vx1 = "50%";
                vy1 = "0";
                vx2 = "50%";
                vy2 = "100%";
                break;
        }
        return (<div id="tar" ref="tar" style={imgstyle}>
                <svg width="100%" height="100%">
                    {(() => {
                        switch (type) {
                            case 'Rectangle':
                                return (
                                    <React.Fragment>
                                        <rect width="100%" height="100%"
                                              style={{
                                                  fill: BorderHelpers.GetFill(Fill, FillColor),
                                                  stroke: BorderColor,
                                                  strokeWidth: BorderWidth + 'pt',
                                                  strokeDasharray: BorderHelpers.strokeArray(BorderStyle, BorderWidth)
                                              }}
                                        />
                                    </React.Fragment>)
                            case 'Lines':
                                return (
                                    <React.Fragment>
                                        <line x1={vx1} y1={vy1} x2={vx2} y2={vy2}
                                              style={{
                                                  stroke: BorderColor,
                                                  strokeWidth: BorderWidth + 'pt',
                                                  strokeDasharray: BorderHelpers.strokeArray(BorderStyle, BorderWidth),
                                                  minWidth: '0',
                                                  minHeight: '0'
                                              }}
                                        />
                                    </React.Fragment>)
                            case 'Ellipse':
                                return (
                                    <React.Fragment>
                                        <ellipse cx="50%" cy="50%" rx="50%" ry="50%"
                                                 style={{
                                                     stroke: BorderColor,
                                                     strokeWidth: BorderWidth + 'pt',
                                                     strokeDasharray: BorderHelpers.strokeArray(BorderStyle, BorderWidth),
                                                     minWidth: '0',
                                                     minHeight: '0',
                                                     fill: BorderHelpers.GetFill(Fill, FillColor)
                                                 }}
                                        />
                                    </React.Fragment>)
                        }
                    }).call(this)}
                </svg>
            </div>
        );
    }
}

export default Shape;